import { createReducer, on } from '@ngrx/store';
import { hideSidebarBookmarks, initUserPreferences, resetPanesViewPreferences, resetSplitPaneViewPreference, resetTablesViewPreferences, resetTableViewPreferences, setLanguage, setThemeMode, showSidebarBookmarks, updateSplitPaneViewPreference, updateTableViewPreferences } from './view-preferences.actions';
import { initialState, State } from './view-preferences.state';

export const reducer = createReducer(
  initialState,

  on(initUserPreferences, (state: State, { viewPreferences }) => {
    return {
      ...state,
      ...(viewPreferences.language ? { language: viewPreferences.language } : {}),
      ...(viewPreferences.tables ? { tables: viewPreferences.tables } : {}),
      ...(viewPreferences.sidebar ? { sidebar: viewPreferences.sidebar } : {}),
      ...(viewPreferences.theme ? { theme: viewPreferences.theme } : {}),
      ...(viewPreferences.panes ? { panes: viewPreferences.panes } : {}),
    };
  }),

  on(updateTableViewPreferences, (state: State, { tableId, tableState }) => ({
    ...state,
    tables: {
      ...state.tables,
      [tableId]: tableState,
    },
  })),
  on(resetTableViewPreferences, (state: State, { tableId }) => {
    const otherTables = { ...state.tables };
    delete otherTables[tableId];
    return {
      ...state,
      tables: otherTables,
    };
  }),
  on(resetTablesViewPreferences, (state: State) => ({
    ...state,
    tables: null,
  })),

  on(setLanguage, (state: State, { langId }) => ({
    ...state,
    language: langId,
  })),

  on(setThemeMode, (state: State, { theme }) => ({
    ...state,
    theme,
  })),

  on(updateSplitPaneViewPreference, (state: State, { paneId, pane }) => ({
    ...state,
    panes: {
      ...state.panes,
      [paneId]: pane,
    },
  })),
  on(resetSplitPaneViewPreference, (state: State, { paneId }) => {
    const panes = { ...state.panes };
    delete panes[paneId];
    return {
      ...state,
      panes,
    };
  }),
  on(resetPanesViewPreferences, (state: State) => ({
    ...state,
    panes: {},
  })),

  on(showSidebarBookmarks, (state: State) => ({
    ...state,
    sidebar: {
      ...state.sidebar,
      bookmarks: true,
    },
  })),
  on(hideSidebarBookmarks, (state: State) => ({
    ...state,
    sidebar: {
      ...state.sidebar,
      bookmarks: false,
    },
  })),
);
